import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-relatorio-laudo',
  templateUrl: './card-relatorio-laudo.component.html',
  styleUrls: ['./card-relatorio-laudo.component.scss']
})
export class CardRelatorioLaudoComponent implements OnInit {

  @Input() status:number|string = '';
  @Input() titulo = '';

  constructor() { }

  ngOnInit() {
  }

}
